import { Component, EventEmitter, Input, OnInit, OnDestroy, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { Subject } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-motivo-anulacion-dialog',
  templateUrl: './motivo-anulacion-dialog.component.html',
  styleUrls: ['./motivo-anulacion-dialog.component.scss'],
})
export class MotivoAnulacionDialogComponent implements OnInit, OnDestroy {
  @Input() maxCharacters: number = 500;
  @Input() minCharacters: number = 10;
  @Input() anularDisplayDialog: boolean = false;
  @Input() titulo: string = 'Anular Acta';
  @Input() isProcessing: boolean = false;
  @Output() confirmar = new EventEmitter<string>();
  @Output() cancelar = new EventEmitter<void>();

  datosAnulacionForm!: FormGroup;
  caracteresRestantes!: number;
  caracteresActuales: number = 0;
  progressPercentage: number = 0;
  isMinimumReached: boolean = false;

  private destroy$ = new Subject<void>();

  constructor(private readonly formBuilder: FormBuilder) {}

  ngOnInit(): void {
    this.datosAnulacionForm = this.formBuilder.group({
      motivo: [
        null,
        [
          Validators.required,
          Validators.minLength(this.minCharacters),
          Validators.maxLength(this.maxCharacters),
          this.noOnlyWhitespace,
        ],
      ],
    });

    this.actualizarCantidadCaracteres();

    this.datosAnulacionForm
      .get('motivo')
      ?.valueChanges.pipe(debounceTime(300), takeUntil(this.destroy$))
      .subscribe(() => {
        this.actualizarCantidadCaracteres();
      });
  }

  private noOnlyWhitespace(control: AbstractControl) {
    const value = control.value;
    if (!value) return null;
    return value.trim().length > 0 ? null : { whitespace: true };
  }

  actualizarCantidadCaracteres(): void {
    const currentLength = this.datosAnulacionForm.get('motivo')?.value?.length || 0;
    this.caracteresActuales = currentLength;
    this.caracteresRestantes = this.maxCharacters - currentLength;
    this.progressPercentage = (currentLength / this.maxCharacters) * 100;
    this.isMinimumReached = currentLength >= this.minCharacters;
  }

  get characterCounterClass(): string {
    if (this.caracteresActuales < this.minCharacters) return 'text-warning';
    if (this.caracteresActuales > this.maxCharacters * 0.9) return 'text-danger';
    if (this.isMinimumReached) return 'text-success';
    return '';
  }

  get textareaLabel(): string {
    return `${this.titulo} - Mínimo ${this.minCharacters} caracteres, máximo ${this.maxCharacters}`;
  }

  get isFieldInvalid(): boolean {
    const motivoControl = this.datosAnulacionForm.get('motivo');
    return !!(motivoControl?.invalid && motivoControl?.touched);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onSubmitAnular(): void {
    if (this.datosAnulacionForm.valid) {
      this.confirmar.emit(this.datosAnulacionForm.get('motivo')?.value);
      this.datosAnulacionForm.reset();
      this.onCancel();
    }
  }
  onCancel(): void {
    this.datosAnulacionForm.reset();
    this.actualizarCantidadCaracteres();
    this.cancelar.emit();
  }
}
